import { useEffect, useState } from "react";
import { Mail, Youtube, Music2, Heart } from "lucide-react";
import { getChannel, formatViews } from "@/lib/api";

const About = () => {
  const [channel, setChannel] = useState(null);
  useEffect(() => {
    getChannel().then(setChannel).catch(() => {});
  }, []);

  return (
    <div className="max-w-[1100px] mx-auto px-4 sm:px-8 py-12" data-testid="about-page">
      <div className="hero-gradient rounded-3xl border border-[var(--border)] p-8 sm:p-14">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
          {channel?.avatar && (
            <img
              src={channel.avatar}
              alt="Abel Andrade"
              className="w-28 h-28 rounded-full border-4 border-[var(--accent)] shadow-2xl"
            />
          )}
          <div>
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[var(--accent)]">
              <Music2 className="w-4 h-4" /> Canal oficial
            </div>
            <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-2 leading-tight">
              Abel <span className="text-[var(--accent)] italic">Andrade</span>
            </h1>
            <p className="text-[var(--text-dim)] mt-2">{channel?.tagline || "Criações com alma e coração."}</p>
          </div>
        </div>
      </div>

      <div className="mt-10 grid sm:grid-cols-3 gap-4">
        <Stat label="Vídeos" value={channel?.stats?.video_count ?? "—"} />
        <Stat label="Shorts" value={channel?.stats?.shorts_count ?? "—"} />
        <Stat label="Visualizações" value={channel ? formatViews(channel.stats.total_views) : "—"} />
      </div>

      <div className="mt-10 p-6 sm:p-8 rounded-2xl bg-[var(--bg-elevated)] border border-[var(--border)]">
        <h2 className="font-display text-2xl font-semibold mb-4 flex items-center gap-2">
          <Heart className="w-5 h-5 text-[var(--accent)] fill-[var(--accent)]" /> Sobre o canal
        </h2>
        <p className="whitespace-pre-wrap text-[var(--text-dim)] leading-relaxed">
          {channel?.description || ""}
        </p>
      </div>

      <div className="mt-8 flex flex-wrap gap-3">
        <a
          href={channel?.youtube_url || "https://www.youtube.com/@abelandrade-youtube"}
          target="_blank"
          rel="noreferrer"
          className="pill pill-primary"
          data-testid="about-youtube-button"
        >
          <Youtube className="w-4 h-4" /> Subscrever no YouTube
        </a>
        <a
          href={`mailto:${channel?.contact || "andradeabel@hotmail.com"}`}
          className="pill"
          data-testid="about-email-button"
        >
          <Mail className="w-4 h-4" /> {channel?.contact || "andradeabel@hotmail.com"}
        </a>
      </div>
    </div>
  );
};

const Stat = ({ label, value }) => (
  <div className="p-6 rounded-2xl bg-[var(--bg-elevated)] border border-[var(--border)]">
    <div className="font-display text-3xl font-semibold">{value}</div>
    <div className="text-[11px] uppercase tracking-[0.18em] text-[var(--text-muted)] mt-1">{label}</div>
  </div>
);

export default About;
